import * as _cloneDeep from 'lodash/cloneDeep';

export function cloneDeep(obj) {
    // todo change to cloneDeep<T>(obj: T): T
    return _cloneDeep(obj);
}
